import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";  
import { useDispatch } from "react-redux"
import getDateFromString from "../../../utils/getDateFromString" 
import { updatePaymentInspector } from "../../../store/action/payment"; 
import {CompleteMissionExpert } from "../../../store/action/wsPI.js";
import * as Actions from "../../../store/action/payment.js";  
import {addPaymentMissionExpert} from "../../../store/action/missionExpert.js";
const useStyles = makeStyles((theme) => ({
    card: {  
        backgroundColor: 'white',
        width:"100%",  
        border: '0.61px solid rgba(226, 217, 239, 1)',
        borderRadius:'12px'
    },
    cardTitle: {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 500,
        LineHeight :'21px',
        marginBottom: '20px', 
    },
    cardText: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500, 
        color: 'rgba(128, 128, 143, 1)', 
    },
    cardValue: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        color: 'rgba(24, 28, 50, 1)',
        textAlign : 'Right', 
    },
    styleInput : {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        border : 0,
        background: "rgba(243, 246, 249, 1)", 
        color: 'rgba(24, 28, 50, 0.58)',
        lineHeight : '21px' , 
        textAlign : 'Right',
        padding : '5px',
        Width :'209px',
        Height :'28px',
        borderRadius:'4px'
    },
    styleTextArea : {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        border : "1px solid rgba(0, 0, 0, 0.2)",
        background: "rgba(255, 255, 255, 1)", 
        color: 'rgba(24, 28, 50, 0.58)',
        lineHeight : '21px' ,  
        padding : '5px',
        minWidth :'305px',
        minHeight :'77px',
        borderRadius:'4px',
        resize: 'none',
    },
    TextContainer: {
        display: 'flex',
        justifyContent: 'space-between', 
        margin : '10px 15px', 
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'end', 
        alignItems: 'center',
        height:"48px" ,
        background:"rgba(244, 244, 244, 1)" ,
        borderBottomLeftRadius:'12px',
        borderBottomRightRadius:'12px', 
    },
    annulerStyle: { 
        width: '100px', height: '35px',
        backgroundColor: 'rgba(255, 229, 229, 1)', 
        marginRight : '20px',
        borderRadius:'5.38px',
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600,
        color:'rgba(255, 54, 54, 1)',
        border : 0,
    },
    valideStyle: { 
        width: '100px', height: '35px',
        backgroundColor: 'rgba(60, 101, 86, 1)',
        color: 'rgba(255, 255, 255, 1)', 
        marginRight : '20px',
        borderRadius:'5.38px',
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600, 
        border : 0,
    }


}));
 
const RegulationsExpert = ({  isTaskClaimed , data , setAction , actionPI }) => {
    const classes = useStyles(); 
     const dispatch = useDispatch();
    const [honoraireExpert , setHonoraireExpert ] = useState(data);
 
    const handleInputChange = (event) => {
        const value = event.target.value;
        event.target.value = value.replace(/[^0-9.,]|([,.][0-9]*[,.])/g, '');
      };

    const updateData = (name, value) => { 
        setHonoraireExpert((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const sendToPI = async () => {
      console.log("honoraireExpert : " , honoraireExpert)
          let isSuccess = false;
          let message = "";
           
            const res = await CompleteMissionExpert(honoraireExpert);
            console.log("res : ", res.success)
            isSuccess = res.success;
            message = res.message || "";
            if (isSuccess) {
              await addPaymentMissionExpert(honoraireExpert);
            }
           
    
          const newStatus = isSuccess ? "PIOK" : "PIKO";
          console.log("newStatus : ", newStatus)
          await dispatch(Actions.updatePaymentStatus(honoraireExpert._id, newStatus, message));
          setAction(true)
      }
     
   

    const handleValider = async () => {
        honoraireExpert.status ="APPROVED"
        const reponse = await updatePaymentInspector(honoraireExpert);
        setAction(true)
        setHonoraireExpert(reponse)
    };
    const handleRejeter = async () => {
        honoraireExpert.status ="REFUSED"
        const reponse = await updatePaymentInspector(honoraireExpert);
        setAction(true)
        setHonoraireExpert(reponse)
    };
    return (
        <div className={classes.card}  >
                        <div className={classes.TextContainer}>
                            <div className={classes.cardTitle}>Honoraire Expert</div>
                             
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Status</div>
                            <div className={classes.cardValue} style={{color :'rgba(255, 168, 0, 1)'}}>{ honoraireExpert.status ||'N/A'}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Type Mission</div>
                            <div className={classes.cardValue}>{honoraireExpert.missionType ||'N/A'}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Type expert </div>
                            <div className={classes.cardValue}>{honoraireExpert.inspectorType ||'N/A'}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Expert </div>
                            <div className={classes.cardValue}>{honoraireExpert.inspector ||'N/A'}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Cause/Bien</div>
                            <div className={classes.cardValue}>{honoraireExpert.inspectorType ||'N/A'}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Date désignation</div>
                            <div className={classes.cardValue}>{getDateFromString(honoraireExpert?.designationDate?.toString())} </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Date saisie Honoraire</div>
                            <div className={classes.cardValue}> {getDateFromString(honoraireExpert?.feeEntryDate?.toString())}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Date MAJ Honoraire</div>
                            <div className={classes.cardValue}> {getDateFromString(honoraireExpert?.feeUpdateDate?.toString())}</div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Frais Timbre</div>
                            <div className={classes.cardValue}> 
                                <input  disabled={isTaskClaimed} className={classes.styleInput} 
                                    type="number"  step="any" min="0"
                                    onInput= {handleInputChange}
                                    name="stampFee" 
                                    value = {honoraireExpert.stampFee}
                                    onChange={(e) => updateData(e.target.name, e.target.value)}
                                    />
                                </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Montant expertise</div>
                            <div className={classes.cardValue}><input  disabled={isTaskClaimed} className={classes.styleInput} 
                                type="number"  step="any" min="0"
                                    onInput= {handleInputChange}
                                name="totalAmountTcc"  
                                value = {honoraireExpert.totalAmountTcc}
                                onChange={(e) => updateData(e.target.name, e.target.value)}/>
                            </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Frais de déplacement</div>
                            <div className={classes.cardValue}><input  disabled={isTaskClaimed} className={classes.styleInput} 
                                type="number"  step="any" min="0"
                                    onInput= {handleInputChange} 
                                name="travelFee" 
                                value = {honoraireExpert.travelFee} 
                                onChange={(e) => updateData(e.target.name, e.target.value)}/> 
                            </div>
                         </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Montant des déductions</div>
                            <div className={classes.cardValue}><input  disabled={isTaskClaimed} className={classes.styleInput} 
                                type="number"  step="any" min="0"
                                    onInput= {handleInputChange} 
                                name="deductionAmounts" 
                                value = {honoraireExpert.deductionAmounts}
                                onChange={(e) => updateData(e.target.name, e.target.value)}/> 
                            </div>
                         </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Facture</div>
                            <div className={classes.cardValue}><input  disabled={isTaskClaimed} className={classes.styleInput} 
                                type="text"  
                                name="invoice"   
                                value = {honoraireExpert.invoice}
                                onChange={(e) => updateData(e.target.name, e.target.value)}/> 
                            </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Date facturation</div>
                            <div className={classes.cardValue}><input  disabled={isTaskClaimed} className={classes.styleInput} 
                                type="date"  
                                name="invoiceDate" 
                                style={{ width: 175  }} 
                                value= {honoraireExpert?.invoiceDate ? new Date(honoraireExpert.invoiceDate).toISOString().slice(0, 10) : ''}
                                onChange={(e) => updateData(e.target.name, e.target.value)}/> 
                            </div>
                        </div>
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText}>Note</div>
                            <div className={classes.cardValue}><textarea  disabled={isTaskClaimed} className={classes.styleTextArea}
                                name="note"  
                                value = {honoraireExpert.note} 
                                onChange={(e) => updateData(e.target.name, e.target.value)}/> 
                            </div>
                        </div>
                        {honoraireExpert.motifPI &&<div className={classes.TextContainer}>
                            <div className={classes.cardText}>motif PI</div>
                            <div className={classes.cardValue}>{honoraireExpert.motifPI}</div>
                        </div>}
                        <div className={classes.TextContainer}>
                            <div className={classes.cardText} style={{color :'rgba(187, 200, 8, 1)'}}>Montant du à l’expert</div>
                            <div className={classes.cardValue} style={{color :'rgba(187, 200, 8, 1)'}}>{honoraireExpert.inspectionAmount}</div>
                        </div>
                         
                {isTaskClaimed?<></> : (
                    <div className={classes.buttonContainer}>
                        {actionPI  ? (
                            <button className={classes.valideStyle} onClick={sendToPI}>Envoyer à PI</button>
                        ) :
                         (<>
                         <button className={classes.annulerStyle} onClick={handleRejeter}>Rejeter</button>
                         <button className={classes.valideStyle} onClick={handleValider}>Valider Réglement</button></>)
                        }
                            
                    </div>
                )}
            
        </div>
        
    );
}

export default RegulationsExpert;